import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CurrencyConverterPurePipe } from 'app/shared/currency-converter-pure.pipe';
import { TransportsService } from 'app/shared/modals/modal-transports/transports.service';
import { ModalsComponent } from 'app/shared/modals/modals.component';
import { TransportsComponent } from 'app/home/search-box/categories/transports/transports.component';

@Component({
  selector: 'usb-suggestions-item',
  templateUrl: './suggestions-item.component.html',
  styleUrls: ['./suggestions-item.component.scss'],
  providers: [CurrencyConverterPurePipe]
})
export class SuggestionsItemComponent implements OnInit, OnChanges {
  @Input() suggestions: any;
  @Input() item: any;
  @Input() showCategory: any;
  @Input() clientSetting: any;
  @Input() currencyAgency: any;
  @Input() currencies: any;
  @Input() paymentAgencyActive: any;
  @Input() actualItinerary: any;
  @Output() reloadEmmit = new EventEmitter();
  styleSidebar: any;
  styleBody: any;
  modalTours:any;
  suggestionsArr: any[] = [];
  suggestionArrTransfer: any[] = [];
  loadingSuggestionArr: boolean = true;
  dialogRef: any;

  constructor(public dialog: MatDialog, private currencyPipe: CurrencyConverterPurePipe, private tranportService: TransportsService) { }


  ngOnChanges(changes: SimpleChanges): void {
   if(changes && changes['suggestions'] && changes['suggestions']['currentValue'] && Array.isArray(changes['suggestions']['currentValue'])) {

    const suggestionArr: any[] = changes['suggestions']['currentValue'];
    if(suggestionArr && suggestionArr.length > 0) {
      const suggestionCategoryId: number = suggestionArr[0].categoryId || suggestionArr[0].category;

      if(suggestionCategoryId > 0) {
        // Usar copia para evitar mutar el array original que viene del padre
        this.suggestionsArr = [...suggestionArr];
        this.loadingSuggestionArr = false;
      }
    }

   }
  }

  ngOnInit() {
    this.tranportService.clearAssignment();
      this.styleSidebar = JSON.parse(this.clientSetting?.clients_setting_app_booking?.bookingFlow_sidebar);
      this.styleBody = JSON.parse(this.clientSetting?.clients_setting_app_booking?.bookingFlow_body);

      // Solo pushear placeholders si ngOnChanges aún no cargó datos reales
      if (this.suggestionsArr.length === 0 && this.suggestions) {
        this.loadingSuggestionArr = true;
        for(let i = 0; i < 2; i++) {
          this.suggestionsArr.push(this.suggestions);
        }
      }
  }

  openModal(product: any, payload: any): void {

 if(!payload || !product) {
   return;
 }
    const category = payload?.categoriesId[0];

    if(!category) {
      console.warn('No hay categoría definida');
      return;
    }

    switch(category) {
      case 1:
        break;
      case 6:
      case 9:
        this.dialogRef = this.dialog.open(ModalsComponent, {
          width: "100%",
          height: "100%",
          maxWidth: '950px',
          disableClose: true,
          data: {
            modalRoomRef: this.modalTours,
            product: this.normalizeSuggestionTour(product),
            productQty: payload,
            // form: this.form,
            origin: 'TOURS',
            arrayResults: [{searchId: product.searchId, component: 'suggestion_itinerary'}],
            tabActive: 'tour',
            payloadUpdate: payload,
            paymentAgencyActive: this.paymentAgencyActive,
            quote: true,
            action: 'suggestion',
            from: 'individual'
          },
        });
        break;
      case 8:
        if (product.is_suggestion === true) {
          // Sugerencia de traslado → abrir buscador con datos pre-llenados
          const pickup = payload?.transfers?.pickupLocation;
          const dropoff = payload?.transfers?.dropoffLocation;

          const formTransportSuggestion = {
            firstOrigin: pickup ? {
              id: pickup.id,
              name: pickup.name,
              address: pickup.address,
              type: pickup.type,
              iata: pickup.iata_code,
              latitude: pickup.latitude,
              longitude: pickup.longitude,
              city_name: '',
              country_code: '',
            } : null,
            firstDestination: null,
            firstArrivalDate: payload?.pickupDate || null,
            firstTime: payload?.transfers?.pickupTime || null,
            firstQtyAdults: payload?.transfers?.paxList?.adults || 0,
            firstQtyChilds: payload?.transfers?.paxList?.children?.length || 0,
            firstChildsage: payload?.transfers?.paxList?.children || [],
            type: 'oneTrip'
          }

          this.dialogRef = this.dialog.open(TransportsComponent, {
            width: '85%',
            height: 'auto',
            minHeight: '320px',
            data: {
              clientSetting: this.clientSetting,
              component: 'results',
              category: 8,
              payload: [payload],
              formTransport: formTransportSuggestion,
              paymentAgencyActive: this.paymentAgencyActive,
              navigateToResults: true,
            },
          });
        } else {
          // Traslado normal → abrir modal de producto
        this.dialogRef = this.dialog.open(ModalsComponent, {
            width: "100%",
            height: "100%",
            maxWidth: '1240px',
            data: {
              vehicles: this.normalizeSuggestionVehicles(product?.vehicles),
              product: this.normalizeSuggestionVehicles(product?.vehicles),
              departureDate: payload.departureDate,
              productQty: payload.qtyProduct,
              flyingInfo: this.actualItinerary?.fly,
              formTransport: {
                firstArrivalDate: payload.pickupDate,
                firstDestination: payload.transfers?.dropoffLocation,
                firstOrigin: payload.transfers?.pickupLocation,
                firstTime: '',
                firstChildsage: payload.transfers?.paxList?.children,
                firstQtyChilds: payload.transfers?.paxList?.children?.length,
                firstQtyAdults: payload.transfers?.paxList?.adults,
                type: 'oneTrip'
              },
              form: {
                firstArrivalDate: payload.pickupDate,
                firstDestination: payload.transfers?.dropoffLocation,
                firstOrigin: payload.transfers?.pickupLocation,
                firstTime: '',
                firstChildsage: payload.transfers?.paxList?.children,
                firstQtyChilds: payload.transfers?.paxList?.children?.length,
                firstQtyAdults: payload.transfers?.paxList?.adults,
                type: 'oneTrip'
              },
              origin: "TRANSPORTS",
              arrayResults: [{searchId: product.searchId, component: 'suggestion_itinerary'}],
              tabActive: 'product',
              payload: payload,
              paymentAgencyActive: this.paymentAgencyActive,
              quote: true,
              action: 'suggestion',
              from: 'individual'
            },
          });
        }
        break;
    }

    this.dialogRef.afterClosed().subscribe((result: any) => {

                 if(result === 'success' || result === 'add' || result) {
                   this.reloadEmmit.emit();
                 }
               })
  }

getPrice(item): number {
  let price: number;
  const category = item.categoryId || item.category;

  switch(category) {
    case 6:
    case 9:
      // Tours - acceder a additionalInfo desde el product parseado
      const productTours = item.product ? (typeof item.product === 'string' ? JSON.parse(item.product) : item.product) : {};
      const additionalInfo = productTours.additionalInfo || item.additionalInfo;
      const tourOption = additionalInfo?.tours?.options?.[0];
      const paxPrice = tourOption?.paxPrices?.find(c => c.paxType === 'ADULT');

      price = paxPrice?.amount || item.price_from;

      price = this.currencyPipe.transform(
        price,
        additionalInfo?.currency || item.currency || 'ARS',
        this.currencyAgency?.code,
        this.currencies
      );
      break;
    case 8:
      // Transfers - intentar desde product parseado o directamente desde item
      const productTransfer = item.product ? (typeof item.product === 'string' ? JSON.parse(item.product) : item.product) : {};
      const vehicles = productTransfer.vehicles || item.vehicles;

      if (vehicles && vehicles[0]) {
        price = vehicles[0].totalPriceProf;
        price = this.currencyPipe.transform(
          price,
          vehicles[0]?.pricing?.currency || item.currency || 'ARS',
          this.currencyAgency?.code,
          this.currencies
        );
      } else {
        // Fallback: usar price_from directo
        price = item.price_from;
        price = this.currencyPipe.transform(
          price,
          item.currency || 'ARS',
          this.currencyAgency?.code,
          this.currencies
        );
      }
      break;
  }

return price;
}

getDurations(options: any): string {

           return this.getDurationsArr(options);

}

/**
 * Procesa y formatea las duraciones disponibles en las opciones,
 * eliminando duplicados y retornando un string formateado
 * @param options - Array de objetos con información de tours/actividades
 * @returns String con duraciones únicas formateadas separadas por comas
 */
getDurationsArr(options: any): string {
  if (!options || !Array.isArray(options)) {
    return '';
  }

  const durationsSet = new Set<string>();

  options.forEach((option: any) => {
    if (option.duration) {
      const durations = Array.isArray(option.duration)
        ? option.duration
        : [option.duration];

      durations.forEach((duration: string) => {
        if (duration && typeof duration === 'string') {
          const formattedDuration = this.builderDuration(duration);
          if (formattedDuration) {
            durationsSet.add(formattedDuration);
          }
        }
      });
    }
  });

  const durationsArray = Array.from(durationsSet);
  return durationsArray.join(', ');
}


/**
 * Convierte un string de duración en formato técnico a formato legible
 * @param timeString - Duración en formato "valor-tipo" (ej: "1-DAYS")
 * @returns String formateado para mostrar al usuario
 */
builderDuration(timeString: string): string {
  try {
    const parts = timeString.split('-').map((part: string) => part.trim());

    if (parts.length !== 2) {
      return 'N/A';
    }

    const value = parseInt(parts[0], 10);
    const type = parts[1].toUpperCase();

    if (isNaN(value)) {
      return 'N/A';
    }

    if (type === 'DAYS' || type === 'days') {
      if (value === 1) {
        return '1 Día';
      } else {
        return `${value} Días`;
      }
    } else if (type === 'HOURS' || type === 'hours') {
      return `${value} Horas`;
    } else if(type === 'MINUTES' || type === 'minutes') {
       return `${value} minutos`;
    }

    else {
      return `${value} ${type}`;
    }
  } catch (error) {
    return 'N/A';
  }
}

  /**
   * Normaliza los vehicles de una sugerencia de transfer para que tengan la misma
   * estructura que un producto cotizado. El modal de transportes espera
   * vehicle.profility.netPriceBooking y vehicle.profilityEntry.netPriceBooking.
   *
   * Mapea:
   * - pricing.totalPrice → profility (netPriceBooking, netPrice, etc.)
   * - pricing.totalPrice → profilityEntry (mismo valor para ida)
   */
  private normalizeSuggestionVehicles(vehicles: any[]): any[] {
    if (!vehicles || vehicles.length === 0) return vehicles;

    return vehicles.map(vehicle => {
      const clone = { ...vehicle };
      const pricing = clone.pricing;

      if (pricing && !clone.profility) {
        const basePrice = pricing.totalPrice || pricing.priceWithoutTax || 0;
        clone.profility = {
          netPriceBooking: basePrice,
          netPrice: basePrice,
          netPriceProf: basePrice,
          netPriceCategory: basePrice,
          netPriceProvider: basePrice,
          netPriceFreeTax: basePrice,
          currency: pricing.currency,
          percentage: 0,
          // Campos de rentabilidad que el backend exige (ItinerariesController TRANSPORTS)
          // Las sugerencias no tienen estos datos → default 0
          percentageCategory: 0,
          percentageProvider: 0,
          percentageBooking: 0,
          // Blickoins — el backend los lee de item.profility.blickoins
          blickoins: 0,
          creditBlickoins: 0,
        };
      }

      if (pricing && !clone.profilityEntry) {
        const basePrice = pricing.entryTotalPrice || pricing.totalPrice || pricing.priceWithoutTax || 0;
        clone.profilityEntry = {
          netPriceBooking: basePrice,
          netPrice: basePrice,
          netPriceProf: basePrice,
          netPriceCategory: basePrice,
          netPriceProvider: basePrice,
          netPriceFreeTax: basePrice,
          currency: pricing.currency,
          percentage: 0,
          percentageCategory: 0,
          percentageProvider: 0,
          percentageBooking: 0,
          blickoins: 0,
          creditBlickoins: 0,
        };
      }

      // Propiedades que el modal/addToItinerary espera directamente en el item raíz
      if (pricing) {
        const basePrice = pricing.totalPrice || pricing.priceWithoutTax || 0;
        if (!clone.netPriceFreeTax) clone.netPriceFreeTax = basePrice;
        if (!clone.totalPriceFreeTax) clone.totalPriceFreeTax = basePrice;
        if (!clone.netPriceUnitaryFreeTax) clone.netPriceUnitaryFreeTax = basePrice;
        // El backend lee blickoins/creditBlickoins del item raíz
        if (!clone.blickoins) clone.blickoins = 0;
        if (!clone.creditBlickoins) clone.creditBlickoins = 0;
      }

      return clone;
    });
  }

  /**
   * Normaliza un producto de sugerencia de tour para que tenga la misma estructura
   * que un producto cotizado. El modal de tours espera campos específicos que las
   * sugerencias no tienen (profility, prices, pricing, cancellation_policy).
   *
   * Mapea:
   * - paxPrices → profility (para generateCoordinates, getPaxPricesType)
   * - paxPrices → prices (para generateCalendar)
   * - paxPrices → pricing (para generateCalendar días del mes anterior)
   * - availableDates[].cancellationPolicies → cancellation_policy (para template)
   */
  private normalizeSuggestionTour(product: any): any {
    if (!product?.additionalInfo?.tours?.options) return product;

    const deepClone = JSON.parse(JSON.stringify(product));
    const options = deepClone.additionalInfo.tours.options;

    options.forEach((option: any) => {
      const paxPrices = option.paxPrices || [];

      // profility: array con netPriceBooking por paxType (usa generateCoordinates)
      if (!option.profility && paxPrices.length > 0) {
        option.profility = paxPrices.map((p: any) => ({
          paxType: p.paxType,
          netPriceBooking: p.amount,
          netPrice: p.amount,
          netPriceProf: p.amount,
          netPriceCategory: p.amount,
          netPriceProvider: p.amount,
          // Campos de rentabilidad que el backend exige (ItinerariesController TOURS)
          // Las sugerencias no tienen estos datos → default 0
          percentage: 0,
          percentageCategory: 0,
          percentageProvider: 0,
          percentageBooking: 0,
          blickoins: 0,
          creditBlickoins: 0,
        }));
      }

      // prices: array con amountProf (usa generateCalendar para días del mes actual/siguiente)
      if (!option.prices && paxPrices.length > 0) {
        option.prices = paxPrices.map((p: any) => ({
          paxType: p.paxType,
          amountProf: p.amount,
        }));
      }

      // pricing: array con netPriceProf por paxType (usa generateCalendar para días del mes anterior)
      if (!option.pricing && paxPrices.length > 0) {
        option.pricing = paxPrices.map((p: any) => ({
          paxType: p.paxType,
          netPriceProf: p.amount,
          netPriceFreeTax: p.amount,
          totalPriceFreeTax: p.amount,
          totalPriceProf: p.amount,
          blickoins: 0,
          creditBlickoins: 0,
          percentage: 0,
        }));
      }

      // cancellation_policy: extraer del primer availableDate que tenga cancellationPolicies
      if (!option.cancellation_policy && option.availableDates?.length > 0) {
        const firstWithPolicies = option.availableDates.find(
          (d: any) => d.cancellationPolicies && d.cancellationPolicies.length > 0
        );
        if (firstWithPolicies) {
          option.cancellation_policy = firstWithPolicies.cancellationPolicies;
        }
      }

      // Asegurar campos mínimos que el modal espera
      if (!option.addonsIncluded) option.addonsIncluded = [];
      if (option.netPriceBookingAddons === undefined) option.netPriceBookingAddons = 0;
    });

    return deepClone;
  }

}
